export default __webpack_public_path__ + "static/media/Zahl-4.708a51b4.png";